/**
 * Element UI – Buy button form
 */

/*
<?php
/!**
 * Реализация кнопки быстрого скачивания CSP для авторизованных пользователей
 * Скрипт вставляется в блок друпала и работает на выбранных страницах
 * Для вывода необходимо вставить: <csp-fastdownload-button></csp-fastdownload-button>
 *!/
// Предустановленные, интересующие значения меню
$menu_options = [
  'csp50_win',
  'csp50_mac',
  'csp50_deb64',
  'csp50_rpm64',
  'csp50_deb_arm64',
  'csp50_rpm_arm64',
  'csp50_win_cert',
  'csp50_mac_cert',
  'csp50_deb64_cert',
  'csp50_rpm64_cert',
  'csp50_deb_arm64_',
  'csp50_rpm_arm64_',
];

// Заполняем массив данных из всех возможных хуков "getfast_array_options"
foreach (module_invoke_all('getfast_array_options') as $option) {
  if (in_array($option->product_code, $menu_options)) {
    $options[] = [$option->product_code, $option->filename];
  }
}
?>

<script>
cpSite.module.cspFastButton.state.cspArrayOptions = <?php echo json_encode($options); ?>;
</script>
*/

import config from './config'
import cpSite from './cpSite'
import { loadScript } from './loadScript'
import { waitModuleReady } from './waitModuleReady'

let init = false

const cspFastButton = {
  depend: ['vue', 'element-ui'],
  state: {
    cspArrayOptions: [],
    lib: config.DEVMODE ? ['js/embed-csp-fast-button/cspDownloadButton.js'] : [config.THEME + 'js/embed-csp-fast-button/cspDownloadButton.js'],
    isActive: false
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: cspFastButton')
    }
    // Не проводить повторную инициализацию
    if (init) return

    // Критерий дальнейшего запуска
    const querySelector = 'csp-fastdownload-button'
    const fastButtonEl = document.querySelector(querySelector)
    // Если объекта нет, то ничего не делать
    if (!fastButtonEl) {
      if (config.DEVMODE) {
        console.log('cspFastButton: no element')
      }
      return
    }

    // Инициализация
    this.initialize(this)
    // Ожидание готовности новых скриптов
    waitModuleReady(() => (window.Vue && window.Vue.options.components?.ElButton), () => { this.embedCspButton() }, 30)
  },
  initialize () {
    cpSite.module.elementUi.activate()
    init = true
  },
  embedCspButton () {
    loadScript(this.state.lib[0])
    this.state.isActive = true
  }
}
export default cspFastButton
